import { setCookie, getCookie } from './functions'

(function($) {


function scroll_to_elem(elem){

	var is_mobile = $(window).width() < 768 ? true : false;

	var mobile_header = is_mobile ? 30 + $('.wrap').height() : 0;

	//mobile_header = mobile_header && $('body').hasClass('sticky') ? 76 : 0;

	

	var el_top = elem.offset().top;

	

	if(el_top){

		$('html, body').animate({

			scrollTop: elem.offset().el_top - mobile_header

		}, 500);

	}

	

}



function on_off_btn(btn,acc_name,acc_class) {

	var btn_status = $(btn).hasClass('active');

	btn_status = btn_status ? 'active' : 'inactive';

	setCookie(acc_name, btn_status, 60);

	if(btn_status == 'active'){

		$('body').addClass(acc_class);

	} else {

		$('body').removeClass(acc_class);

	}

}



function get_acc_cookie(acc) {

	var btn = getCookie(acc);

	if( btn == 'active' ){

		$('#accessibility-links .toggle-btn[data-acc="'+acc+'"]').addClass('active');

		$('body').addClass('acc-'+acc);

	} else {

		$('body').removeClass('acc-'+acc);

		$('#accessibility-links .toggle-btn[data-acc="'+acc+'"]').removeClass('active');

	}

}



function get_acc_fontsize_cookie() {

	var data = getCookie('fontsize');

	if(!data){

		data = 0;

	}

	$('.acc-font-size-btns a').each(function(){

		var btn_fs = $(this).data('fs');

		if(btn_fs == data){

			$('body').addClass('acc-fs-'+btn_fs);

			$(this).addClass('active');

		} else {

			$('body').removeClass('acc-fs-'+btn_fs);

			$(this).removeClass('active');

		}

	});

}

	

$(document).on('click','.open-accessibility', function() {

	if( $('body').hasClass('acc-open') ){

		$('body').removeClass('acc-open');

	} else {

		$('body').addClass('acc-open');

	}

});



$(document).on('click','.acc-open .wrapper', function() {

	$('body').removeClass('acc-open');

});



$(document).on('click','.toggle-btn', function() {

	$(this).toggleClass('active');

});



$(document).on('click','#accessibility-links .toggle-btn', function() {

	

	var btn = $(this);

	var acc_name = $(btn).data('acc');

	var acc_class = 'acc-'+acc_name;

	

	if(acc_name){

		on_off_btn(btn,acc_name,acc_class);

	}

	

});



$(document).on('click','.acc-font-size-btns a', function() {

	var btn = $(this);

	var current_status = btn.hasClass('active');

	var btn_size = btn.data('fs');

	$('.acc-font-size-btns a').each(function(){

		var s_btn_size = $(this).data('fs');

		if(s_btn_size == btn_size){

			$(this).addClass('active');

		} else {

			$(this).removeClass('active');

		}

	});

	

	setCookie('fontsize', btn_size, 60);

	get_acc_fontsize_cookie();

});



$(document).on('click','.reset-acc a', function() {

	$('.dm-accessibility .active').each(function(){

		$(this).removeClass('active');

	});

	reset_acc();

});



function reset_acc(){

	setCookie('bnw', 'inactive', 60);

	setCookie('hicon', 'inactive', 60);

	setCookie('underline', 'inactive', 60);

	setCookie('fontar', 'inactive', 60);

	setCookie('fontsize', '0', 60);	

	setCookie('disani', 'inactive', 60);	

	setCookie('skl', 'inactive', 60);	

	refresh_acc();

}



function refresh_acc(){

	get_acc_cookie('bnw');

	get_acc_cookie('hicon');

	get_acc_cookie('underline');

	get_acc_cookie('fontar');

	get_acc_cookie('disani');

	get_acc_cookie('skl');

	get_acc_fontsize_cookie();

}



$(document).ready( function(){

	refresh_acc();

	$('.acc-skl .skiplinkim a').first().focus();

	

	$('.skiplinkim a[data-acc-target]').each( function(){

		var target = $(this).data('acc-target');

		$(target).attr('tabindex','0');

	});

	

});





/* skiplinks */

$(document).on('keypress','.skiplinkim a', function(e) {

	

	if(!e.which == 13) {

        return false;

    }

	

	var a_link = $(this);

	var li_parent = a_link.parent();

	var ul_parent = li_parent.parent();



	var has_sub_links = li_parent.find('ul').length;

	if(has_sub_links){

		$(this).parent().find('ul li:nth-child(2) a').first().focus();

	} else {

		if( a_link.hasClass('prev-skip') )

			ul_parent.parent().find('a').first().focus();

		else {

			var target = a_link.data('acc-target');

			$(target).focus();

		}

	}

	e.preventDefault();

	

});

$(document).on('keypress','.acc-skl *',function(e) {

	

	if(!e.which == 13) {

        return false;

    }

	$(this).click();

});



$(document).on('keyup',function(evt) {

    if (evt.keyCode == 27) {

       $('.skiplinkim > ul > li:first-child a').focus();

    }

});



$(document).on('focus','.skiplinkim a', function() {

	var a_link = $(this)

	

	if( a_link.hasClass('back-to-first') ){

		a_link.parent().parent().find('li:first-child a').focus();

	} else {

		var highlight = a_link.data('highlight');

		if(highlight){

			$(highlight).addClass('highlight');

			//scroll_to_elem($(highlight));			

		}

			

	}

	

});



$(document).on('blur','*', function() {

	$('.highlight').removeClass('highlight');

});



/* end jQuery */

})(jQuery);